(function (global) {
  function loadScene7Script(callback) {
    if (window.s7viewers && window.s7viewers.VideoViewer) {
      callback();
      return;
    }

    if (window._scene7Loading) {
      // Already loading — queue the callback
      window._scene7Callbacks = window._scene7Callbacks || [];
      window._scene7Callbacks.push(callback);
      return;
    }

    window._scene7Loading = true;
    window._scene7Callbacks = [callback];

    var script = document.createElement("script");
    script.src = "https://s7d9.scene7.com/s7viewers/html5/js/VideoViewer.js";
    script.onload = function () {
      var cbs = window._scene7Callbacks || [];
      cbs.forEach(function (cb) { cb(); });
      window._scene7Callbacks = [];
    };
    document.head.appendChild(script);
  }

  global.Scene7Loader = { load: loadScene7Script };
})(window);